<template>
<div>
  <v-autocomplete :disabled="empresa.id == 0" v-model="unidade" label="Unidades" :items="unidades" item-text="nome" return-object>
  </v-autocomplete>
</div>
</template>

<script>
import service from '../../../services/userservice'
// import {
//   EventBus
// } from './../main'

export default {
  name: 'unidade-select',
  props: {
    mEmpresa: Object
  },
  data () {
    return {
      unidades: [],
      multiUnidades: [],
      unidadesProcessamento: [],
      unidadeProcessamento: {
        idCidade: 0,
        idUnidadeNegocio: 0,
        idUnidadeProcessamento: 0
      },
      unidade: null,
      empresa: { id: 0 }
    }
  },
  watch: {
    unidade (val) {
      this.$emit('get-unidade', val)
    },
    mEmpresa (val) {
      this.empresa = val
      this.listarUnidades()
    }
  },
  methods: {
    listarUnidades () {
      this.load = true
      let idUnidadeNegocio = 0
      let idEmpresa = 0
      if (this.empresa != null) {
        idEmpresa = this.empresa.id
        idUnidadeNegocio = 0
      } else if (this.unidadeProcessamento != null) {
        idUnidadeNegocio = this.unidadeProcessamento.id
        idEmpresa = this.unidadeProcessamento.idEmpresa
      }
      service.listarUnidades({
        idUnidadeNegocio: idUnidadeNegocio,
        idEmpresa: idEmpresa
      }).then(r => {
        if (r.status === 200) {
          this.unidades = r.data
        } else if (r.status === 203) {}
      }).finally(() => {
        this.load = false
      })
    }
  },
  mounted () {
  }
}
</script>
